import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children, role }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="eyebrow">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
    if (role === "admin" && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    if (role === "clinic") {
        if (user.role === "clinic" && user.status !== "approved") {
            return <Navigate to="/pending" replace />;
        }
    }
    return children;
}
